(function () {
  'use strict';

  angular
      .module('tf.retailer.Util')
      .filter('user', user);

  function user() {
    return function (user) {
      if (user) {
        return user.firstName + ' ' + user.lastName + ' <' + user.email + '>';
      }
    };
  }

})();
